/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MicrosoftAspNetCoreMvcProblemDetails,
  ResponseNotification,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Notifications<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Notifications
   * @name GetConsultTranscriptionNotification
   * @summary Gets the consult transcription notification for the logged in user if they have transcription allowed and haven't read it yet (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v1/notifications/consult-transcription
   * @secure
   * @response `200` `ResponseNotification` Returns the notification
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   * @response `404` `MicrosoftAspNetCoreMvcProblemDetails` User has transcription disabled or has already read the notification
   */
  getConsultTranscriptionNotification = (params: RequestParams = {}) =>
    this.http.request<
      ResponseNotification,
      void | MicrosoftAspNetCoreMvcProblemDetails
    >({
      path: `/api/v1/notifications/consult-transcription`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name GetNotifications
   * @summary Gets valid notifications that the logged in user has not read (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v1/notifications
   * @secure
   * @response `200` `(ResponseNotification)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getNotifications = (params: RequestParams = {}) =>
    this.http.request<ResponseNotification[], void>({
      path: `/api/v1/notifications`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name ReadNotification
   * @summary Marks a Notification as read by the logged in user (Auth policies: GuestOrClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v1/notifications/{notificationId}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  readNotification = (notificationId: number, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/notifications/${notificationId}`,
      method: "POST",
      secure: true,
      ...params,
    });
}
